import { render, staticRenderFns } from "./NewServiceRequest.vue?vue&type=template&id=bcf4c58c"
import script from "./NewServiceRequest.vue?vue&type=script&lang=js"
export * from "./NewServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports